import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { GlobalDataService } from '../../../services/global-data.service';

@Injectable()
export class OwnershipTypeService {

  constructor(
              private http: HttpClient, 
              private global: GlobalDataService
              ) { }

  createOwnershipType(data: any){
         return this.http.post(this.global.httpUrl+"ownership-types", data); 
  }

  updateOwnershipType(data: any, id: any){
         return this.http.put(this.global.httpUrl+"ownership-types/"+id, data); 
  }

  getOwnershipType(isActive:number=-1){

        let isAvailable: string ="?active="+isActive;

        if(isActive==-1){
            isAvailable="";
        }

         return this.http.get(this.global.httpUrl+"ownership-types"+isAvailable);
  }

  getOwnershipTypeById(id: string){
         return this.http.get(this.global.httpUrl+"ownership-types/"+id);
  }


}



// WEBPACK FOOTER //
// C:/Users/User/Documents/Projects/Ekopen/angular2-store-test/src/app/dashboard/pages/ownership_types/ownership-type.service.ts